import { render, staticRenderFns } from "./TabPaneHorizontal.vue?vue&type=template&id=4c09b5f2&"
import script from "./TabPaneHorizontal.vue?vue&type=script&lang=js&"
export * from "./TabPaneHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports